/**
 * Resolves an ObjectRecord *code* (e.g. "P-100") to its stored UUID, for
 * staged field writes that arrive with a code instead of a UUID — see
 * `field-write-coercion.ts` for why this is needed (frozen Home
 * Recommendation actions replay LLM-proposed values verbatim, uncoerced).
 *
 * Imperative (not a hook) because it's called from inside an async coercion
 * callback, not a render. Callers supply the API token themselves.
 */

import {getMasterDataApi} from '@/matic/features/master-data/api/master-data-api';
import type {ResolveObjectReferenceCode} from '../utils/field-write-coercion';

export function createObjectReferenceCodeResolver(
  token: string | undefined
): ResolveObjectReferenceCode {
  return async (objectTypeId, code) => {
    const api = getMasterDataApi(token);
    const {items} = await api.listObjectRecords(objectTypeId, {
      search: code,
      limit: 10,
    });
    const match = items.find(
      (record) => record.code.toLowerCase() === code.toLowerCase()
    );
    return match?.id;
  };
}
